import { Button } from "antd";

const CustomButton = ({
  type = "default",
  onClick,
  buttonName,
  icon,
  style = {},
  ...rest
}) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      style={{
        borderRadius: "5px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        ...style,
      }}
      {...rest}
    >
      {icon}
      {buttonName}
    </Button>
  );
};

const PrimaryButton = (props) => (
  <CustomButton
    type="primary"
    style={{
      borderColor: "#cc0e49",
      backgroundColor: "#cc0e49",
      ...props.style,
    }}
    {...props}
  />
);

const SecondaryButton = (props) => (
  <CustomButton
    style={{
      color: "#cc0e49",
      borderColor: "#cc0e49",
      ...props.style,
    }}
    {...props}
  />
);

export { PrimaryButton, SecondaryButton };
